import { render } from "./VoiceAssistant.vue?vue&type=template&id=d9e599de"
import script from "./VoiceAssistant.vue?vue&type=script&lang=js"
export * from "./VoiceAssistant.vue?vue&type=script&lang=js"

import "./VoiceAssistant.vue?vue&type=style&index=0&id=d9e599de&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__